import { forwardRef, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CommonUtilsContext } from 'contexts/commonUtils';
import { ModalTemplateSettings } from 'components/ModalTemplate/types';
import { ModalDefaultProps } from 'components/Modal';
import { Button } from 'components/buttons';
import { ModalTemplate } from 'components/ModalTemplate';

import logo from 'assets/images/jackpot/logo.png';
import bg from 'assets/images/jackpot/modalBg.jpg';

import { ScJackpotModals } from './styled';

export const JackpotTCModal = forwardRef<HTMLDivElement, ModalDefaultProps>(
  ({ onClose }, ref) => {
    const { t } = useTranslation('jackpot');

    const { isMobileS } = useContext(CommonUtilsContext);

    const modalSettings: ModalTemplateSettings = useMemo(() => {
      return isMobileS
        ? {
            type: 'mobile',
            mode: { type: 'default' },
          }
        : {
            type: 'desktop',
            size: 'small',
            mode: { type: 'default' },
          };
    }, [isMobileS]);

    const shortTerms = useMemo(
      () =>
        Object.values(
          t('shortTerms', { returnObjects: true })
        ).map((rule, index) => <div key={index}>{rule as string}</div>),
      [t]
    );

    return (
      <ModalTemplate ref={ref} onClose={onClose} settings={modalSettings}>
        <ScJackpotModals>
          <div className="title">{t('tnc')}</div>
          <div className="img_wrapper">
            <img className="bg" src={bg} alt="" />
            <img className="logo" src={logo} alt="" />
          </div>
          <div className="terms">{shortTerms}</div>
          <div className="btn-wrapper">
            <Button onLinkClick={onClose} to={'/search-games/top'} green xLarge>
              {t('button.hitJackpot')}
            </Button>
          </div>
        </ScJackpotModals>
      </ModalTemplate>
    );
  }
);
